import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginApiMasterService } from 'src/app/login-layout/Service/login-api-master.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
    activeRoute: ActivatedRoute,private loginService: LoginApiMasterService) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
   currentUser = sessionStorage.getItem('currentUser');
  if (currentUser:string) {
    // logged in so return true
    
    return true;
  }
  
  
}
